import React, { useEffect, useState } from "react";
import { InputGroup, Modal, Button } from "../../../../UI";
import Container from "./styles";
import { useSelector, useDispatch } from "react-redux";
import { AttachBike, getBikes } from "../../../../store/actions";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import Checkbox from "./Checkbox";

const AdminForm = (order) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [biker, setBiker] = useState({ride:{id:location.state?.bike_id}});
 
  const { bikeLists } = useSelector((s) => s.AdminData);

  useEffect(() => {
    // Try to fetch bikes but handle if endpoint doesn't exist
    dispatch(getBikes({})).catch(() => {
      // Silently handle - bikes endpoint may not exist
    });
  }, [dispatch]);

  
  function handleSubmit() {
    if (biker != {}) {
      dispatch(AttachBike({ ...biker, ...orderData }, navigate));
    } else {
      toast.error("Add a bike");
    }
  }

 
  const orderData = { orderId: location.state?.id };
  
  // If no state is passed, redirect back
  if (!location.state) {
    navigate('/dashboard/orders');
    return null;
  }
  
  return (
    <Container>
      <Modal showModal={true}>
        <div className="adminForm--container">
            <h2 style={{ color: "#fff", fontWeight: "600", textAlign:"center" }}>
              {location.state?.reference}
            </h2>
          <header>
            <h2 style={{ color: "#fff", fontWeight: "600" }}>
              List of available bikes
            </h2>
          </header>
          <div
            style={{
              height: "400px",
              overflow: "scroll",
              overflowX: "hidden",
              paddingLeft: "4em",
              paddingRight: "4em"
            }}
            className="BikeScroll"
          >
            {bikeLists?.data && bikeLists.data.length > 0 ? (
              bikeLists.data.map((ride) => (
                <Checkbox key={ride.id} ride={ride} setBiker={setBiker} biker={biker}/>
              ))
            ) : (
              <div style={{ textAlign: 'center', padding: '2em', color: '#fff' }}>
                <p>No bikes available. This feature may not be configured yet.</p>
              </div>
            )}
          </div>
            <div style={{ padding: 20 }}>
              <Button
                onClick={() => {
                  handleSubmit();
                }}
                full
              >
                Add Bike
              </Button>
            </div>
        
        </div>
      </Modal>
    </Container>
  );
};

export default AdminForm;
